// store/slices/loadingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  global: false,
  dashboard: false,
  alerts: false,
  prices: false,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setGlobalLoading: (state, action) => {
      state.global = action.payload;
    },
    setDashboardLoading: (state, action) => {
      state.dashboard = action.payload;
    },
    setAlertsLoading: (state, action) => {
      state.alerts = action.payload;
    },
    setPricesLoading: (state, action) => {
      state.prices = action.payload;
    },
    resetLoading: () => initialState,
  },
});

export const {
  setLoading,
  setGlobalLoading,
  setDashboardLoading,
  setAlertsLoading,
  setPricesLoading,
  resetLoading,
} = loadingSlice.actions;

// Selectors
export const selectLoading = (state) => state.loading;

export default loadingSlice.reducer;